import React from "react";
import Fade from "react-reveal/Fade";

export default function LoadingScreen() {
  return (
    <Fade duration={400} delay={100}>
      <div className="loading-screen">
        <span className="loader">
          <span className="loader-inner" />
        </span>
      </div>
    </Fade>
  );
}
